import { useCompanyHasReportCards, useCompanySportTerminology } from '../../../lib/stores/company.store';
import { pluralTerm } from '../../../lib/helpers/term.helper';
import { SportTerminology } from '../../../lib/types'; 
import { MemberListOption } from './member-list.types';
import { MEMBER_GROUP_ROLES, MemberListType, ROLE_DESCRIPTIONS, ROLE_LABELS, ROLES, ROLES_TABLE_KEYS } from '../../../../_configuration';

export const useMemberColumnListOptions =() => {
  const hasReportCards = useCompanyHasReportCards()
  const termLookup = useCompanySportTerminology()
  const athletesTerm = pluralTerm(termLookup[SportTerminology.ATHLETE].toLowerCase())
  const sessionsTerm = pluralTerm(termLookup[SportTerminology.SESSION].toLowerCase())

  const defaultColumns = [
    { key: 'name', label: 'Name', path: 'member.user.name' },
    { key: 'all', label: 'All Roles', disableSort: true },
  ]

  const configOption = { key: ROLES_TABLE_KEYS[ROLES.CONFIGURATION], label: ROLE_LABELS[ROLES.CONFIGURATION], disableSort: true, role: ROLES.CONFIGURATION };
  // Scope-agnostic roles source `helper` from ROLE_DESCRIPTIONS (shared with the
  // other member lists); scope-specific roles keep an inline per-scope helper.
  const manageUsersOption = { key: ROLES_TABLE_KEYS[ROLES.USER_MANAGEMENT], label: ROLE_LABELS[ROLES.USER_MANAGEMENT], disableSort: true, helper: ROLE_DESCRIPTIONS[ROLES.USER_MANAGEMENT], role: ROLES.USER_MANAGEMENT };
  const communicationOption = { key: ROLES_TABLE_KEYS[ROLES.COMMUNICATION], label: ROLE_LABELS[ROLES.COMMUNICATION], disableSort: true, helper: ROLE_DESCRIPTIONS[ROLES.COMMUNICATION], role: ROLES.COMMUNICATION };

  const ageGroupRoles = MEMBER_GROUP_ROLES[MemberListType.AGE_GROUP]
  const ageGroupOptions: MemberListOption[] = [
    ...defaultColumns,
    ...[
      { key: ROLES_TABLE_KEYS[ROLES.PLAYER_NAMES], label: termLookup[SportTerminology.ATHLETE] + ' Names', disableSort: true, role: ROLES.PLAYER_NAMES, helper: `Allows access to ${termLookup[SportTerminology.ATHLETE].toLowerCase()} names while evaluating ${athletesTerm}` },
      { key: ROLES_TABLE_KEYS[ROLES.REPORTS], label: ROLE_LABELS[ROLES.REPORTS], disableSort: true, role: ROLES.REPORTS, helper: `Allows access to summary reports${hasReportCards ? "," : " and"} detailed ${termLookup[SportTerminology.ATHLETE]} scores${hasReportCards ? ", and report cards" : ""}` },
      {...configOption, helper: `Allows access to create and edit ${athletesTerm}`},
      manageUsersOption,
      communicationOption,
    ].sort((a, b) => ageGroupRoles.findIndex(ar => ar === a.role) - ageGroupRoles.findIndex(ar => ar === b.role))
  ];

  const assessmentRoles = MEMBER_GROUP_ROLES[MemberListType.ASSESSMENT]
  const assessmentOptions: MemberListOption[] = [
    ...defaultColumns,
    ...[
      { key: ROLES_TABLE_KEYS[ROLES.CHECK_IN], label: ROLE_LABELS[ROLES.CHECK_IN], disableSort: true, role: ROLES.CHECK_IN, helper: 'Allows access to check-in ' + athletesTerm},
      { key: ROLES_TABLE_KEYS[ROLES.SCORING], label: ROLE_LABELS[ROLES.SCORING], disableSort: true, role: ROLES.SCORING, helper: `Allows access to evaluation tools and upcoming ${sessionsTerm}` },
      {...configOption, helper: `Allows access to create and edit age groups`},
      communicationOption,
    ].sort((a, b) => assessmentRoles.findIndex(ar => ar === a.role) - assessmentRoles.findIndex(ar => ar === b.role))
  ];

  const superRoles = MEMBER_GROUP_ROLES[MemberListType.SUPER]
  const superUserOptions: MemberListOption[] = [
    ...defaultColumns,
    ...[
      {...configOption, helper: `Allows access to import and create ${sessionsTerm} and assessment scheduling configuration`},
      { key: ROLES_TABLE_KEYS[ROLES.CONFIG_DRILLS], label: ROLE_LABELS[ROLES.CONFIG_DRILLS], disableSort: true, role: ROLES.CONFIG_DRILLS, helper: `Allows access to edit and create ${pluralTerm(termLookup[SportTerminology.METRIC])}, ${pluralTerm(termLookup[SportTerminology.EVENT])}, and practice plans`},
      manageUsersOption,
      communicationOption,
    ].sort((a, b) => superRoles.findIndex(ar => ar === a.role) - superRoles.findIndex(ar => ar === b.role))
  ];

  return {ageGroupOptions, assessmentOptions, superUserOptions}
}
